import React, { useState } from 'react'
import {
  RichTextContainer,
  RichTextLabel,
  RichTextSpan,
} from './RichText.styled'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { RichTextProps } from './RichText.props'
import { RichTextEditor, RichTextEvent } from 'models/editor.model'

const RichText = ({ label, required, onChange }: RichTextProps) => {
  const [text, setText] = useState<string>('')
  return (
    <RichTextContainer>
      {label && (
        <RichTextLabel>
          {label}
          {required && <RichTextSpan>*</RichTextSpan>}
        </RichTextLabel>
      )}
      <CKEditor
        editor={ClassicEditor}
        data={text}
        onChange={(event: RichTextEvent, editor: RichTextEditor) => {
          const data = editor.getData()
          setText(data)
          onChange && onChange(data)
        }}
      />
    </RichTextContainer>
  )
}

export default RichText
